import { BUSINESS, PERSON, TUPAS, UNIDENTIFIED } from "./enums";

const REDIRECT_URL = {
  private: {
    en: "/private-customers/customer-service",
    fi: "/henkiloasiakkaat/asiakaspalvelu",
    sv: "/privatkunder/kundtjanst",
  },
  corporate: {
    en: "/corporate-customers/customer-service",
    fi: "/yritykset/asiakaspalvelu",
    sv: "/foretagskunder/kundtjanst",
  },
};

export function getRedirectUrl(customerType, locale) {
  switch (customerType) {
    case PERSON:
    case TUPAS:
    case UNIDENTIFIED:
      return REDIRECT_URL["private"][locale];
    case BUSINESS:
      return REDIRECT_URL["corporate"][locale];
    default:
      return;
  }
}
